module.exports = __webpack_public_path__ + "img/planilha-upload.60c05903.png";